module.exports = __webpack_public_path__ + "66ff52b37ec3f61901696a48d735966a.svg";